export type InscriptionMediaSource = "thumbnail" | "image" | "external-image" | "document";
export type InscriptionMediaFailureAction = "retry" | "image" | "external-image" | "document";

export const INSCRIPTION_THUMBNAIL_RETRY_LIMIT = 2;

export function inscriptionMediaFailureAction(
  source: InscriptionMediaSource,
  attempt: number,
): InscriptionMediaFailureAction {
  if (source === "thumbnail") {
    return attempt >= INSCRIPTION_THUMBNAIL_RETRY_LIMIT ? "image" : "retry";
  }
  // An unavailable image proxy does not mean the inscription is HTML. Try
  // the browser-loadable original before embedding a native-size document.
  if (source === "image") return "external-image";
  return "document";
}
